import React from "react";
import {
  Box,
  Heading,
  Link,
  List,
  ListItem,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  VStack,
} from "@chakra-ui/react";
import { Link as RouterLink } from "react-router-dom";

function scrollToBlogSection(e) {
  e.preventDefault();
  const el = document.getElementById("blog-section");
  if (el) {
    el.scrollIntoView({ behavior: "smooth" });
    window.history.replaceState(null, '', '#blog-section');
  } else {
    window.location.href = "/blog#blog-section";
  }
}

export default function CreditAndLoanGuide() {
  return (
    <Box maxW="1000px" mx="auto" px={{ base: 4, md: 8 }} py={{ base: 20, md: 32 }}>
      <VStack spacing={6} align="start">
        <Link
          as="button"
          onClick={scrollToBlogSection}
          aria-label="Back to Blog"
          position="fixed"
          top={{ base: "84px", md: "96px" }}
          left={{ base: 4, md: 8 }}
          zIndex="sticky"
          bg="white"
          color="teal.600"
          fontWeight="semibold"
          border="1px solid"
          borderColor="teal.100"
          borderRadius="full"
          px={{ base: 0, sm: 4 }}
          py={{ base: 0, sm: 2 }}
          w={{ base: "42px", sm: "auto" }}
          h={{ base: "42px", sm: "auto" }}
          display="inline-flex"
          alignItems="center"
          justifyContent="center"
          boxShadow="sm"
          _hover={{ textDecoration: "none", bg: "teal.50" }}
        >
          <Text as="span" display={{ base: "inline", sm: "none" }}>←</Text>
          <Text as="span" display={{ base: "none", sm: "inline" }}>← Back to Blog</Text>
        </Link>

        <Heading as="h1" size="xl" mb={2} mt={16}>Credit and Loan Guide for Newcomers in Canada (2026)</Heading>
        <Text fontSize="sm" color="gray.500">
          By Heavenly • March 09, 2026 • 5 mins read
        </Text>

        <Text>
          For newcomers, borrowing in Canada is easier when you build a clear financial profile early. This guide
          covers practical steps to establish credit, qualify for safer loan products, and avoid common mistakes.
        </Text>

        <Heading as="h2" size="md">First 90 Days Checklist</Heading>
        <List spacing={2} pl={4} styleType="disc">
          <ListItem>Open a primary chequing account</ListItem>
          <ListItem>Set up direct deposit if employed</ListItem>
          <ListItem>Apply for an entry-level secured or newcomer credit card</ListItem>
          <ListItem>Put recurring bills on autopay where possible</ListItem>
        </List>

        <Heading as="h2" size="md">Common Credit-Building Routes</Heading>
        <Table variant="simple">
          <Thead>
            <Tr>
              <Th>Route</Th>
              <Th>Best For</Th>
              <Th>Time to Build History</Th>
            </Tr>
          </Thead>
          <Tbody>
            <Tr>
              <Td>Secured credit card</Td>
              <Td>Starting from limited history</Td>
              <Td>3-6 months</Td>
            </Tr>
            <Tr>
              <Td>Entry unsecured card</Td>
              <Td>Stable income + basic profile</Td>
              <Td>6-12 months</Td>
            </Tr>
            <Tr>
              <Td>Small installment loan</Td>
              <Td>Building payment record</Td>
              <Td>6-12 months</Td>
            </Tr>
          </Tbody>
        </Table>

        <Heading as="h2" size="md">What Lenders Usually Review</Heading>
        <List spacing={2} pl={4} styleType="disc">
          <ListItem>Income consistency and employment stability</ListItem>
          <ListItem>Debt-to-income ratio</ListItem>
          <ListItem>Payment history on current accounts</ListItem>
          <ListItem>Credit utilization on revolving products</ListItem>
          <ListItem>Accuracy of identity and address information</ListItem>
        </List>

        <Heading as="h2" size="md">Borrowing Safely as a Newcomer</Heading>
        <List spacing={2} pl={4} styleType="disc">
          <ListItem>Start with smaller borrowing amounts</ListItem>
          <ListItem>Compare total repayment, not only monthly payment</ListItem>
          <ListItem>Avoid multiple loan applications in a short period</ListItem>
          <ListItem>Keep card balances low before applying for larger loans</ListItem>
        </List>

        <Heading as="h2" size="md">Mistakes to Avoid</Heading>
        <List spacing={2} pl={4} styleType="disc">
          <ListItem>Missing first payments on new accounts</ListItem>
          <ListItem>Using most of your available card limit</ListItem>
          <ListItem>Borrowing beyond realistic monthly affordability</ListItem>
          <ListItem>Ignoring loan terms and fee details</ListItem>
        </List>

        <Heading as="h2" size="md">Final Thoughts</Heading>
        <Text>
          Newcomer credit growth is achievable with consistency. Focus on on-time payments, low utilization, and
          accurate records, then scale borrowing gradually as your profile strengthens.
        </Text>
        <Box mt={10} width="100%" textAlign="center">
          <Heading as="h3" size="md" mb={3} color="teal.700">Get an instant loan now with Swift Credit</Heading>
          <Link as={RouterLink} to="/apply" onClick={() => { window.scrollTo({ top: 0, behavior: 'smooth' }); }}>
            <Box as="button" bg="teal.500" color="white" px={8} py={3} borderRadius="md" fontWeight="bold" _hover={{ bg: "teal.600" }}>
              Get a Loan
            </Box>
          </Link>
        </Box>
      </VStack>
    </Box>
  );
}
